
import { profanity } from '@2toad/profanity';
import sentiment from 'wink-sentiment';

// Initialize custom profanity filter
const customBlacklist = [
  'scam',
  'rug',
  'ponzi',
  'fake',
  'fraud',
  'illegal',
  'celebrity',  // Add names that might violate celebrity rights
  'trademark',  // Add names that might violate trademarks
  // Add more prohibited terms
];

// Add custom blacklist words to the profanity filter
profanity.addWords(customBlacklist);

export const screenCoinName = (name: string): {
  isApproved: boolean;
  reasons: string[];
  sentimentScore: number;
} => {
  const reasons: string[] = [];
  
  // Check for profanity
  if (profanity.exists(name.toLowerCase())) {
    reasons.push('Contains prohibited words');
  }

  // Check name length
  if (name.length < 3 || name.length > 32) {
    reasons.push('Name length must be between 3 and 32 characters');
  }

  // Check for valid characters
  if (!/^[a-zA-Z0-9\s]+$/.test(name)) {
    reasons.push('Name can only contain letters, numbers, and spaces');
  }
  
  // Check for impersonation patterns (very basic)
  const lowerName = name.toLowerCase();
  if (lowerName.includes('official') || lowerName.includes('verified')) {
    reasons.push('Avoid using terms that may imply official status');
  }

  // Perform sentiment analysis
  const sentimentResult = sentiment(name);
  
  return {
    isApproved: reasons.length === 0 && sentimentResult.score >= -0.5,
    reasons,
    sentimentScore: sentimentResult.score
  };
};

export const reportCoinName = async (
  coinName: string,
  reason: string,
  reporterAddress: string
): Promise<void> => {
  // In a full implementation, this would interact with a smart contract
  console.log('Name reported:', { coinName, reason, reporterAddress });
  // For now, we'll just log the report
  
  // In a production environment, this could:
  // 1. Store the report in Supabase
  // 2. Trigger a notification to moderators
  // 3. Track frequency of reports for the same token
};
